import { always, filter, ifElse, isNil, map, pipe, uniq } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { PROMOTION_ITEM_TYPES } from '../../../constants';
import { checkIsActivePromo } from '../../../utils';
import { usePromotionsSelector } from '../../store';
import {
  Bonus,
  PromotionApiItem,
  PromotionsState,
  Selector
} from '../../types';

export const selectActiveBonuses = (): Selector<Bonus[] | []> =>
  createSelector(
    (state: PromotionsState) => state.promotions,
    ifElse(
      isNil,
      always([]),
      pipe(
        filter(
          (promotion: PromotionApiItem) =>
            promotion.type === PROMOTION_ITEM_TYPES.BONUS &&
            !!promotion.bonusTemplateId &&
            promotion.enabled &&
            checkIsActivePromo(promotion.showFrom, promotion.showTo, false)
        ),
        uniq,
        map(
          (promotion: PromotionApiItem): Bonus => ({
            ...promotion
          })
        )
      )
    )
  );

export const useGetActiveBonuses = () =>
  usePromotionsSelector(selectActiveBonuses, [], shallow);
